import type { BidLevel } from '@/features/bidding/types/bidLadder'

export const BID_LEVELS: BidLevel[] = [
  // Up market bids
  {
    volumeMW: 50,
    cumulativeVolumeMW: 50,
    clearingProbability: 0.9,
    market: 'up',
    pricing: {
      type: 'fixed',
      fixedPrice: 30,
      avgPrice: 30,
    },
  },
  {
    volumeMW: 75,
    cumulativeVolumeMW: 125,
    clearingProbability: 0.8,
    market: 'up',
    pricing: {
      type: 'fixed',
      fixedPrice: 35,
      avgPrice: 35,
    },
  },
  {
    volumeMW: 80,
    cumulativeVolumeMW: 305,
    clearingProbability: 0.3,
    market: 'up',
    pricing: {
      type: 'fixed',
      fixedPrice: 48,
      avgPrice: 48,
    },
  },
  // Down market bids
  {
    volumeMW: 50,
    cumulativeVolumeMW: 50,
    clearingProbability: 0.9,
    market: 'down',
    pricing: {
      type: 'fixed',
      fixedPrice: 25,
      avgPrice: 25,
    },
  },
  {
    volumeMW: 75,
    cumulativeVolumeMW: 125,
    clearingProbability: 0.8,
    market: 'down',
    pricing: {
      type: 'fixed',
      fixedPrice: 30,
      avgPrice: 30,
    },
  },
  {
    volumeMW: 80,
    cumulativeVolumeMW: 305,
    clearingProbability: 0.3,
    market: 'down',
    pricing: {
      type: 'fixed',
      fixedPrice: 42,
      avgPrice: 42,
    },
  },
]
